/*
 * Copyright (c) 2023. Haodong JU
 */

import { hillo } from 'hillo'
import dayjs from 'dayjs'
import { Remember } from '@/model/global/GlobalSettings'
import _ from 'lodash'
import { comparator } from '@/model/dataLayer/service/DashboardService'

export async function previewZBonByTimeSpan (startTime, endTime) {
  if (startTime === endTime) {
    endTime = dayjs().format('YYYY-MM-DD HH:mm:ss')
  } else {
    endTime = dayjs(endTime).endOf('date').format('YYYY-MM-DD HH:mm:ss')
  }
  return (await hillo.get('ZBon.php?op=previewByTimeSpan', {
    startTime,
    endTime
  })).content
}

// 后端接口经常切换
export async function getServantList () {
  return (await hillo.get('Servant.php')).content
}

export async function getBillListForServant (pw = null, date, endDate) {
  return (await hillo.get('BackendData.php?op=mobileV3StatWithLang', {
    pw,
    date,
    endDate,
    lang: Remember.lang.toUpperCase()
  })).content
}

export async function printServantSummaryBonForDateRange (pw, date) {
  // return printServantSummary(pw, ...date)
  return printServantSummary(pw, ...date)
}

export async function servantList (dateRange) {
  return (await getServantData(...dateRange)).servantList.map(bill => {
    const notPay = _.sumBy(bill.orders.filter(i => i.payMethodId === '0'), function (o) {
      return parseFloat(o.totalPrice)
    })
    return {
      ...bill,
      ...bill.servant,
      notPay
    }
  }).sort((a, b) => comparator(
    b.orders?.length ?? 0,
    a.orders?.length ?? 0
  ))
}

export async function printServantSummary (pw, start, end) {
  return (await hillo.get('Servant.php?op=printSummaryBonByPassword', {
    pw,
    start,
    end
  })).content
}

export async function getServantData (start, end) {
  const taxInfo = await previewZBonByTimeSpan(
    dayjs(start).format('YYYY-MM-DD HH:mm:ss'), dayjs(end).format('YYYY-MM-DD HH:mm:ss')
  )
  const servantList = await Promise.all((await getServantList())
    .map(async s => await getBillListForServant(s.password, start, end)))
  return {
    ...taxInfo,
    servantList
  }
}
